<template>
    <table class="improvements-data">
        <thead>
            <td>ID</td>
            <td>Title</td>
            <td>CO₂</td>
            <td>Fuel Bill</td>
            <td>CO₂ Per Pound</td>
            <td>Payback</td>
            <td>Effectiveness</td>
            <td>Status</td>
        </thead>
        <tr v-for="imp in filteredImprovements"
            :key="imp.id">
            <td class="--number">
                {{ imp.id }}
            </td>
            <td>{{ imp.title }}</td>
            <td class="--right --number">
                {{ imp.metrics.find(m => m.key === metricKeys.carbonSaving).value }}
            </td>
            <td class="--right --number">
                {{ imp.metrics.find(m => m.key === metricKeys.fuelBill).value }}
            </td>
            <td class="--right --number">
                {{ imp.efficiencies.co2PerPound }}
            </td>
            <td class="--right --number">
                {{ imp.efficiencies.payback }}
            </td>
            <td class="--right --number">
                {{ imp.efficiencies.effectivenessRating }}
            </td>
            <td class="improvements-data__status">
                <i v-if="imp.recommended" class="fas fa-star" /><i v-if="imp.accepted" class="fas fa-check" />
            </td>
        </tr>
    </table>
</template>

<script>

import Vuex from 'vuex'

import METRIC_KEYS from '@/models/METRIC_KEYS'

import Project from '@/models/project'

export default {

    computed: {
        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Project}
             */
            currentProject: stateStore => Project.ensure(stateStore.improvements.currentProject),

            /**
             * @param {VuexState} stateStore
             * @returns {ImprovementsVuexStateFilters}
             */
            improvementFilters: stateStore => stateStore.improvements.improvementFilters,
        }),

        filteredImprovements() {
            if (this.improvementFilters.recommended && this.improvementFilters.selected) {
                return this.currentProject.addedOrRecommendedImprovements
                    .filter(imp => imp.accepted && imp.recommended)
            }
            if (this.improvementFilters.recommended)
                return this.currentProject.addedOrRecommendedImprovements
            else if (this.improvementFilters.selected)
                return this.currentProject.addedImprovements

            return this.currentProject.availableImprovements
        },

        metricKeys() {
            return METRIC_KEYS
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_improvements-data.scss

.improvements-data {
    font-size: 0.8rem;
    overflow-y: auto;
    overflow-x: hidden;

    > thead {
        font-weight: bold;
    }

    td {
        padding: 0.2rem;
    }

    .--right {
        text-align: right;
    }

    .--number {
        font-family: 'Courier New', Courier, monospace
    }

    @include element('status') {

        i {
            padding: 0 0.1rem;
        }
    }
}

</style>
